import { ExclamationCircleOutlined } from '@ant-design/icons';
import { Modal, Select } from 'antd';
import { CollectionServer, deleteInArray, errorCatch, GET, GETWITH, Model, POST, QueryParam, updateInArray, useAuth } from 'fennec-ui';
import React, {  } from 'react';
import { createUseStyles } from 'react-jss';
import { useDispatch, useSelector } from 'react-redux';
import { getShkolaFromRoles } from '../../../common/Tool';
import User from '../../../common/User';
import AddPrepodavatelShkoli from '../../forms/AddPrepodavatelShkoli';
import PageLayout from '../../components/PageLayout';
import { useSchoolContext } from '../../../common/Context';

var _ = require('lodash');


const { Option } = Select;


const useStyles = createUseStyles({
    block: {
        '& .buttons': {
            marginBottom: "10px"
        },
    },
    item: {
        padding: "5px 10px",
        display: "flex",
        cursor: "pointer",
        '&:hover': {
            backgroundColor: "#f9f9f9"
        }
    },
})

export default function SchoolEducationTeachers(props) {
    const [ctx, setSchool] = useSchoolContext();
    const classes = useStyles();
    const auth = useAuth();
    const dispatch = useDispatch();
   
    const sourceKey = "school";

    const filters = () => [
        {
            label: "Фамилия",
            name: "vtp.user.lastname",
            // type: "string",
            sort: true,
            filter: true,
        },
        {
            label: "Имя",
            name: "vtp.user.firstname",
            // type: "string",
            sort: true,
            filter: true,
        },
        {
            label: "Отчество",
            name: "vtp.user.patronymic",
            // type: "string",
            sort: true,
            filter: true,
        },
        {
            label: "Email",
            name: "vtp.user.email",
            // type: "string",
            sort: true,
            filter: true,
        },
        {
            label: <span>Телефон<span style={{
                fontStyle: "italic",
                fontSize: "11px",
                paddingLeft: "5px",
                color: "#818181"
            }}>(без +)</span></span>,
            name: "vtp.user.phone",
            // type: "string",
            sort: true,
            filter: true,
        },
        {
            label: "Дата рождения",
            name: "vtp.user.birthday",
            type: "date",
            filterType: "range",
            // func: ["min", "max"],
            sort: true,
            filter: true,
        },
        {
            label: "Дата регистрации",
            name: "vtp.dataZapisi",
            type: "date",
            filterType: "range",
            sort: true,
            filter: true,
        },
        {
            label: "Дата подтверждения",
            name: "vtp.dataPodtverzhdeniya",
            type: "date",
            filterType: "range",
            sort: true,
            filter: true,
        },
        {
            label: "Подтверждение",
            name: "vtp.dokumentPodtverzhdeniya.ID",
            // display: (o) => o.nazvanie,
            type: "bool",
            sort: true,
            // filter: true,
        },


        // {
        //     label: "Сезон",
        //     name: "sezon",
        //     filterType: "group",
        //     display: (item) => {
        //         return item.nazvanie
        //     },
        //     queryFilter: [
        //         QueryDetail("model"),
        //         QueryOrder("prioritet", "ASC")
        //     ],
        //     sort: true,
        //     filter: true,
        // },
        // {
        //     label: "Направления танцев",
        //     name: "tantsiSeriiSeriya.tanets",
        //     type: "object",
        //     filterType: "group",
        //     display: (item) => {
        //         return item.nazvanie
        //     },
        //     sort: false,
        //     filter: true,
        //     source: "/api/query/tantsi?detail=model&s-nazvanie=ASC",
        // }
    ];
    
    return (<PageLayout>
        <div>
            <div style={{ padding: "5px 10px", backgroundColor: "white", borderRadius:"4px" }}>
                <div style={{ fontSize: "24px" }}>Школа</div>
                
                {ctx && <CollectionServer
                    title={"Преподаватели школы "+((ctx)?"\""+ctx.nazvanieShkoliTantsev+"\"":"")}
                    name={"UchenikiShkol"}
                    auth={auth}
                    size="small"
                    source={`/api/school/prepodavateli/list/${ctx?.ID}`}
                    filters={filters}
                    // contextFilters={((active && notactive) || (!active && !notactive)) ? undefined : () => [
                    //     If(notactive, QueryParam("w-nu-vtp.dokumentPodtverzhdeniya.ID", "")),
                    //     If(active, QueryParam("w-nnu-vtp.dokumentPodtverzhdeniya.ID", "")),
                    // ]}
                    mode={"list"}
                    render={(item, idx, { setCollection, setCollectionItem, update }) => {
                        const osnovi = _.get(item, "osnoviPromokodovPrepodavatelShkoli[0]")
                        return (<div key={idx} style={{ width: "100%" }} className="students">
                            <div className={classes.item}>
                                <div style={{ flex: "auto" }}>
                                    <User item={item.vtp.user} />
                                    {(osnovi && osnovi?.osnovaPromokoda) && <div style={{ color: "rgb(140, 152, 164)", fontSize: "12px" }}>
                                        <span>Основа промокода: {osnovi?.osnovaPromokoda}</span>
                                    </div>}
                                </div>
                            </div>
                        </div>)
                    }}
                    collectionActions={() => [
                        {
                            action: (values, unlock, close, { collection, setCollection }) => {
                                GET(auth, `/api/add/school/${ctx?.ID}/prepodavatel/${values.polzovatel.ID}`,
                                    ({ data }) => {
                                        setCollection(updateInArray(collection, data));
                                        close();
                                    }, (err) => errorCatch(err, unlock)
                                );
                            },
                            form: AddPrepodavatelShkoli,
                            options: {
                                initialValues: {},
                            },
                            title: "Добавить преподавателя",
                            modal: {
                                minWidth: "250px",
                                title: "Новый преподаватель",
                            }
                        }
                    ]}
                    modelActions={(item) => [
                        {
                            auth: auth,
                            title: <span>Изменить</span>,
                            modal: {
                                title: "Изменить параметры преподавателя школы"
                            },
                            okText: "Сохранить",
                            action: (values, unlock, close, { collection, setCollection }) => {
                                // "/api/osnovipromokodov/new"
                                // "/api/osnovipromokodov/update"
                                // "/api/osnovipromokodov/delete"
                                const osnovi = _.get(item, "osnoviPromokodovPrepodavatelShkoli[0]")

                                if(values?.osnovaPromokoda && values?.osnovaPromokoda!==""){
                                    POST(auth, (!osnovi)?`/api/osnovipromokodov/new`:`/api/osnovipromokodov/update`, {
                                        ID: (osnovi)?osnovi.ID:undefined,
                                    prepodavatelShkoliID: item?.ID,
                                    shkolaFederatsiiID: undefined,
                                    prepodavatelFederatsiiID: undefined,
                                    organizatorFederatsiiID: undefined,
                                    osnovaPromokoda: values?.osnovaPromokoda,
                                }, ({ data }) => {
                                    setCollection(updateInArray(collection, {...item, osnoviPromokodovPrepodavatelShkoli:updateInArray(item?.osnoviPromokodovPrepodavatelShkoli,data)}))
                                    close()
                                    }, (err) => errorCatch(err, () => unlock()))
                                } else if(osnovi){
                                    POST(auth, `/api/osnovipromokodov/delete`, {
                                        ID: (osnovi)?osnovi.ID:undefined,
                                    prepodavatelShkoliID: item?.ID,
                                    shkolaFederatsiiID: undefined,
                                    prepodavatelFederatsiiID: undefined,
                                    organizatorFederatsiiID: undefined,
                                    osnovaPromokoda: values?.osnovaPromokoda,
                                }, ({ data }) => {
                                    setCollection(updateInArray(collection, {...item, osnoviPromokodovPrepodavatelShkoli:[]}))
                                        close()
                                    }, (err) => errorCatch(err, () => unlock()))
                                }

                               
                            },
                            object: _.get(item, "osnoviPromokodovPrepodavatelShkoli[0]"),

                            form: Model,
                            meta: [
                                {
                                    label: "Основа промокода",
                                    description: (<span><i className="fa fa-question-circle"></i> Применяется в качестве префикса при выдаче промокода организатором мероприятия</span>),
                                    name: "osnovaPromokoda",
                                    type: "string",
                                    size: "small"
                                }
                            ]
                        },
                        {
                            title: <span style={{ color: "red" }}>Удалить</span>,
                            modal: {
                                title: "Удалить преподавателя школы?"
                            },
                            action: (values, unlock, close, { collection, setCollection }) => {
                                Modal.confirm({
                                    title: `Вы уверены что хотите удалить преподавателя${(values.blacklist) ? " и добавить его в черный список" : ""}?`,
                                    icon: <ExclamationCircleOutlined />,
                                    content: <User item={item.vtp.user} noborder={true} />,
                                    okText: "Да",
                                    okType: 'danger',
                                    cancelText: "Нет",
                                    onOk: () => {
                                        GETWITH(auth, `/api/delete/school/prepodavatel/admin/${item.ID}`, [
                                            QueryParam("blacklist", values.blacklist)
                                        ], () => {
                                            setCollection(deleteInArray(collection, item));
                                            close();
                                        }, (err) => errorCatch(err, unlock));
                                    },
                                    onCancel: unlock
                                });
                            },
                            okText: "Удалить",
                            dismissText: "Отмена",
                            form: Model,
                            meta: [
                                {
                                    type: "func",
                                    render: (auth, _item) => (<div style={{ paddingBottom: "5px" }}>
                                        <User item={item.vtp.user} noborder={true} />
                                    </div>)
                                },
                                {
                                    label: "Добавить в черный список",
                                    name: "blacklist",
                                    type: "bool",
                                },
                            ],
                        },
                    ]}
                />}
            </div>
        </div>
    </PageLayout>
    );
}
